if (!customElements.get('mikan-model-code')) {
  customElements.define('mikan-model-code', class extends HTMLElement {
    connectedCallback() {
      if (this.observer) return;
      this.schedule = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.fit());
      };
      this.observer = new ResizeObserver(this.schedule);
      this.observer.observe(this.parentElement);
      document.fonts.ready.then(() => { if (this.isConnected) this.schedule(); });
      this.schedule();
    }

    fit() {
      if (!this.isConnected) return;
      const parent = this.parentElement;
      const parentStyle = getComputedStyle(parent);
      const available = parent.clientWidth - parseFloat(parentStyle.paddingLeft) - parseFloat(parentStyle.paddingRight);
      if (available <= 0) return;
      this.style.fontSize = '';
      const naturalWidth = this.getBoundingClientRect().width;
      if (naturalWidth > available) {
        const fontSize = parseFloat(getComputedStyle(this).fontSize);
        this.style.fontSize = `${fontSize * (available - 1) / naturalWidth}px`;
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
      cancelAnimationFrame(this.frame);
    }
  });
}
